import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const keyFor = (slug) => `sm_cart_${slug}`;

export function CartProvider({ slug, children }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(keyFor(slug));
      setItems(raw ? JSON.parse(raw) : []);
    } catch {
      setItems([]);
    }
  }, [slug]);

  const persist = (next) => {
    setItems(next);
    localStorage.setItem(keyFor(slug), JSON.stringify(next));
  };

  const addItem = (line) => persist([...items, { ...line, uid: Date.now() + Math.random() }]);
  const updateQty = (uid, qty) =>
    persist(items.map((i) => (i.uid === uid ? { ...i, quantity: Math.max(1, qty) } : i)));
  const removeItem = (uid) => persist(items.filter((i) => i.uid !== uid));
  const clear = () => persist([]);

  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);
  const estimate = useMemo(() => items.reduce((s, i) => s + i.unit_price * i.quantity, 0), [items]);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, estimate }}>
      {children}
    </CartContext.Provider>
  );
}
